module.exports = __webpack_public_path__ + "static/media/landing-1.3691101e.png";